<h1 mat-dialog-title id="new-dossier-title">
  {{ 'lawyer.dashboard.dossiers.new' | translate }}
</h1>

<mat-dialog-content>
  <form [formGroup]="createForm" aria-labelledby="new-dossier-title">
    <mat-error *ngIf="validation" [innerHTML]="validation | sanitizeHtml"></mat-error>
    <mat-form-field appearance="outline">
      <mat-label>{{ "lawyer.dashboard.dossiers.nameOfNew" | translate }}
        <span class="sr-only">{{ "aria.required" | translate }}</span>
      </mat-label>
      <input matInput formControlName="name" class="name-input" required (keyup)="updateValidation()" />
      <mat-error *ngIf="createForm.get('name').invalid && createForm.get('name').touched">
        {{ "lawyer.dashboard.dossiers.nameRequired" | translate }}
      </mat-error>
    </mat-form-field>
    <app-search-menu [entries]="queryProcesses.bind(this)" (entrySelected)="setProcess($event)" class="process-select"
      *ngIf="permissions.canRead('legal_processes') && commonService.checkFeatureFlagSync('processes.enabled')">
      <button [class.empty]="!createForm.get('fromProcess')?.value?.name" [disabled]="data?.lock?.includes('process')"
        aria-haspopup="true" [attr.aria-label]="'lawyer.dashboard.dossiers.fromProcess' | translate">
        <div class="content">
          <span class="label" translate>{{ 'lawyer.dashboard.dossiers.fromProcess' }}</span>
          <span class="name" *ngIf="createForm.get('fromProcess')?.value">{{
            createForm.get('fromProcess')?.value?.name ?? '' }}</span>
        </div>
        <mat-icon aria-hidden="true">arrow_drop_down</mat-icon>
      </button>
    </app-search-menu>
    <div class="participants" [class.disabled]="data?.lock?.includes('participants')" role="group"
      aria-labelledby="participants-label">
      <mat-label translate id="participants-label">{{ 'common.label.assigned' }}</mat-label>
      <app-dossier-assigned-input [participants]=" createForm.get('participants').value"
        (change)="updateParticipants($event)"></app-dossier-assigned-input>
      <button mat-button (click)="addSelfAsClerk()" class="self-as-clerk" *ngIf="!clerkAdded"
        [attr.aria-label]="'lawyer.dashboard.dossiers.selfAsClerk' | translate">
        <mat-icon aria-hidden="true">camera_front</mat-icon>
        <span>{{ 'lawyer.dashboard.dossiers.selfAsClerk' | translate }}</span>
      </button>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="dialogRef.close()" [attr.aria-label]="'common.button.abort' | translate">
    {{ 'common.button.abort' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="submit()"
    [disabled]="!createForm.get('name').value.length || !!validation"
    [attr.aria-label]="'lawyer.dashboard.dossiers.new' | translate">
    {{ 'lawyer.dashboard.dossiers.new' | translate }}
  </button>
</mat-dialog-actions>